module.exports = __webpack_public_path__ + "static/media/report-adverse-events-600x400.baf1a493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/home/assets/report-adverse-events-600x400.jpg
// module id = 1086
// module chunks = 1